"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnvironmentsModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _Course = require("../Course.labels");
var _Modal = require("../../../../Layout/Modal");
var _Button = require("../../../../UI/Button");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EnvironmentsModal = function EnvironmentsModal(props) {
  var getLabel = (0, _hooks.useLabels)({
    labels: _Course.labels
  });
  var selectedEnvironmentId = props.selectedEnvironmentId,
    environments = props.environments,
    url = props.url,
    title = props.title,
    onConfirm = props.onConfirm,
    onClose = props.onClose;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    environmentSelected = _useState2[0],
    setEnvironmentSelected = _useState2[1];
  (0, _react.useEffect)(function () {
    setEnvironmentSelected(selectedEnvironmentId !== null && selectedEnvironmentId !== void 0 ? selectedEnvironmentId : environments[0].id);
  }, [environments, selectedEnvironmentId]);
  var handleConfirmClick = function handleConfirmClick(event) {
    window.open("".concat(url, "?audience=").concat(environmentSelected));
    if (onConfirm) {
      onConfirm(event, environmentSelected);
    }
    if (onClose) {
      onClose();
    }
  };
  var handleListItemClick = (0, _react.useCallback)(function (environmentId) {
    setEnvironmentSelected(environmentId);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
    isOpen: true,
    onClose: onClose,
    isStandAlone: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('choose_audience'),
      subTitle: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
        children: environments.map(function (environment) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
            id: environment.id,
            color: "primary",
            isSelected: environmentSelected === environment.id,
            onClick: handleListItemClick,
            children: environment.name
          }, environment.id);
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccEnvironmentModalButton",
          view: "outlined",
          color: "primary",
          onClick: handleConfirmClick,
          children: getLabel('confirm')
        })
      })
    })]
  });
};
exports.EnvironmentsModal = EnvironmentsModal;